export const APP_ERROR_KINDS = {
  insufficientCredits: "insufficient-credits",
  rateLimited: "rate-limited",
  unauthenticated: "unauthenticated",
  validation: "validation",
  unknown: "unknown",
} as const;

export type AppErrorKind = (typeof APP_ERROR_KINDS)[keyof typeof APP_ERROR_KINDS];

function errorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (typeof error === "string") return error;
  if (typeof error === "object" && error !== null && "message" in error) {
    const message = error.message;
    return typeof message === "string" ? message : "";
  }
  return String(error);
}

export function classifyAppError(error: unknown): AppErrorKind {
  const message = errorMessage(error).toLowerCase();
  if (/rate.?limit|too many requests|429/.test(message)) {
    return APP_ERROR_KINDS.rateLimited;
  }
  if (/not authenticated|unauthorized|forbidden|401|403/.test(message)) {
    return APP_ERROR_KINDS.unauthenticated;
  }
  if (
    /(?:insufficient|out of|no|exhausted|depleted).{0,40}(?:credit|balance|quota)|(?:credit|balance|quota).{0,40}(?:insufficient|exhausted|depleted|exceeded|top[ -]?up)|no active subscription|subscription (?:is )?(?:inactive|expired|required)|payment required|\b402\b/.test(
      message,
    )
  ) {
    return APP_ERROR_KINDS.insufficientCredits;
  }
  if (/invalid|must be|required|validation/.test(message)) {
    return APP_ERROR_KINDS.validation;
  }
  return APP_ERROR_KINDS.unknown;
}

export function isInsufficientCreditError(error: unknown): boolean {
  return classifyAppError(error) === APP_ERROR_KINDS.insufficientCredits;
}
